import React from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
import { brandContestDialogFooterSx, brandContestDialogPaperSx, editorialHeadlineSx, midnight } from './midnightStyles';

export interface ContestWizardResetConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export function ContestWizardResetConfirmDialog({ open, onClose, onConfirm }: ContestWizardResetConfirmDialogProps) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: brandContestDialogPaperSx }}>
            <Box sx={{ px: 3, pt: 3, pb: 1 }}>
                <Typography sx={{ ...editorialHeadlineSx, fontSize: 20, color: midnight.onSurface, mb: 1.5 }}>
                    Reset campaign setup?
                </Typography>
                <Typography sx={{ color: midnight.onSurfaceVariant, fontSize: 14, lineHeight: 1.6 }}>
                    Your saved draft and all progress on this campaign will be cleared. You will start from the
                    beginning. This cannot be undone.
                </Typography>
            </Box>
            <Box
                sx={{
                    ...brandContestDialogFooterSx,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 1.5,
                }}>
                <Button
                    onClick={onClose}
                    sx={{
                        px: 3,
                        py: 1.25,
                        borderRadius: 999,
                        color: midnight.onSurfaceVariant,
                        fontWeight: 700,
                        fontSize: 12,
                        textTransform: 'uppercase',
                        letterSpacing: '0.08em',
                    }}>
                    No
                </Button>
                <Button
                    onClick={onConfirm}
                    sx={{
                        px: 3,
                        py: 1.25,
                        borderRadius: 999,
                        fontWeight: 800,
                        fontSize: 12,
                        textTransform: 'uppercase',
                        letterSpacing: '0.08em',
                        color: '#392700',
                        background: `linear-gradient(90deg, ${midnight.primary}, #feb700)`,
                    }}>
                    Yes, reset
                </Button>
            </Box>
        </Dialog>
    );
}
